import React, { useState, useEffect } from 'react'
import SingleItem from '../../Components/SingleItem'
import { BasketProvider } from '../../BasketContext';
import './TheMarket.css'

export default function TheMarket() {
    const [items, setItems] = useState([]);

    var currBasket0 = JSON.parse(localStorage.getItem("LocalBasket"));
    const [currBasket, setCurrBasket] = useState(currBasket0);

    useEffect(() => {

        const url = "https://08yvli9kn1.execute-api.us-east-1.amazonaws.com/api/products"
        try {
            fetch(url, { method: 'GET' })
                .then((response) => response.json())
                .then((data) => { setItems(data.data) });
        } catch (ex) {
            console.log(ex)
        }

        const handleStorageChange = () => {
            setCurrBasket(JSON.parse(localStorage.getItem("LocalBasket")));
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };

    }, []);

    return (
        <div>
            {/* <h1 className="header-1">The Market</h1> */}
            <div className="marketbox">
                {items.map((item) => {
                    return (
                        <BasketProvider>
                            <SingleItem Item={item} ></SingleItem>
                        </BasketProvider>)
                })}<div className="market-container"></div>
            </div>
        </div>
    )
}